import { SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { getAppStore } from '../../../bootstrap/redux/store/AppStore';
import { Messages } from '../../../codegen/Localize';
import { ExtractEncryptionMode } from '../../../commonInfra/utils/sites/SitePropertyTypes';
import { ExtractEncryptionState, IDataSourceDetailInfo, IDataSourceInfo } from '../../../datasource/models/IDataSourceInfo';
import { getCommonDatasourceInfo } from '../../../datasource/models/mappers/CommonDatasourceInfo';
import { DataSources } from '../../../datasource/resources/Datasources';
import { EntityActionNames, IEntityAction } from '../../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { hasFileBasedDatasource,
  isAnyPendingExtractStatus,
  isAnyVirtualConnectionDatasource,
  isEncryptionEnabled,
  isEncryptionEnforced,
  isLegalForExtractMoveToTheWeb,
  isSingleDatasourceWithEncyptedExtract,
  isSingleDatasourceWithExtract,
  isSingleDatasourceWithUnencyptedExtract,
  isSingleLiveDatasource } from '../../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';
import { IExtractConvertAction } from '../../../spacesPlatform/models/actionNames';
import { selectSpaceInfo } from '../../../spacesPlatform/selectors/SpaceInfoSelectors';
import { isDatasourceSpace, SpaceInfo } from '../../../spacesPlatform/state/SpaceInfo';
import { createExtractsMethod } from '../../actions/RunCreateExtractsAction';

export const CreateEncryptedExtractForDsAction: IEntityAction<IDataSourceInfo, IExtractConvertAction> = {
    name: EntityActionNames.CreateExtractsEncrypted,
    translateName: Messages.createExtractsForDsSubActionEncrypted,
    isVisible: (targetItems: IDataSourceInfo[], state: AppState, availableActions: IExtractConvertAction) => {
      return isEncryptionEnabled(state);
    },
    isClickable: (availableActions: IExtractConvertAction, targetItems: IDataSourceInfo[], state: AppState) => {
      return isEncryptionEnabled(state) && (isSingleLiveDatasource(targetItems) || isSingleDatasourceWithUnencyptedExtract(targetItems));
    },
    isChecked: (availableActions: IExtractConvertAction, targetItems: IDataSourceInfo[], state: AppState) => {
      return isSingleDatasourceWithExtract(targetItems) && isEncryptionEnabled(state) && isSingleDatasourceWithEncyptedExtract(targetItems);
    },
    createReduxAction: (targetItems: IDataSourceInfo[]) => createExtractsMethod(targetItems, ExtractEncryptionState.encrypted)
};

export const CreateUnencryptedExtractForDsAction: IEntityAction<IDataSourceInfo, IExtractConvertAction> = {
  name: EntityActionNames.CreateExtractsUnencrypted,
  translateName: Messages.createExtractsForDsSubActionUnencrypted,
  isVisible: (targetItems: IDataSourceInfo[], state: AppState, availableActions: IExtractConvertAction) => {
    return isEncryptionEnabled(state);
  },
  isClickable: (availableActions: IExtractConvertAction, targetItems: IDataSourceInfo[], state: AppState) => {
    return isEncryptionEnabled(state) && (isSingleLiveDatasource(targetItems) || isSingleDatasourceWithEncyptedExtract(targetItems));
  },
  isChecked: (availableActions: IExtractConvertAction, targetItems: IDataSourceInfo[], state: AppState) => {
    return isSingleDatasourceWithExtract(targetItems) && isEncryptionEnabled(state) && isSingleDatasourceWithUnencyptedExtract(targetItems);
  },
  createReduxAction: (targetItems: IDataSourceInfo[]) => createExtractsMethod(targetItems, ExtractEncryptionState.unencrypted)
};

export const CreateExtractForDsAction: IEntityAction<IDataSourceDetailInfo, IExtractConvertAction> = {
  name: EntityActionNames.CreateExtracts,
  translateName: (targetItems: IDataSourceDetailInfo[], state: AppState) => {
    if (showEncryptedButtonName(state, targetItems)) {
      return Messages.createExtractsForDsActionEncrypted();
    } else if (showUnencryptedButtonName(state, targetItems)) {
      return Messages.createExtractsForDsActionUnencrypted();
    } else {
      return Messages.createExtractForDsAction();
    }
  },
  isVisible: (targetItems: IDataSourceDetailInfo[], state: AppState, availableActions: IExtractConvertAction) => {
    const spaceInfo: SpaceInfo = selectSpaceInfo(state);
    return isLegalForExtractMoveToTheWeb(targetItems) && isDatasourceSpace(spaceInfo);
  },
  isClickable: (availableActions: IExtractConvertAction, targetItems: IDataSourceDetailInfo[], state: AppState) => {
    return !(availableActions && !availableActions.createExtracts) && isClickableForExtractButton(targetItems, state);
  },
  isChecked: (availableActions: IExtractConvertAction, targetItems: IDataSourceDetailInfo[], state: AppState) => {
    return DataSources.isExtract(getCommonDatasourceInfo(targetItems[0]));
  },
  createReduxAction: (targetItems: IDataSourceDetailInfo[]) => createExtractsMethod(targetItems,
    SessionSiteSelectors.extractEncryptionMode(getAppStore().getState()) === ExtractEncryptionMode.ENFORCED
  ? ExtractEncryptionState.encrypted: ExtractEncryptionState.unencrypted)
};

function showUnencryptedButtonName(state: AppState, targetItems: IDataSourceDetailInfo[]) {
  // case 1) Encryption enable, datasource is Unencrypted extract datasource
  return  !isSingleLiveDatasource(targetItems) && (isEncryptionEnabled(state) || isEncryptionEnforced(state)) && isSingleDatasourceWithUnencyptedExtract(targetItems);
}

function showEncryptedButtonName(state: AppState, targetItems: IDataSourceDetailInfo[]) {
  // case 1) datasource is Encrypted extract datasource
  return  isEncryptionEnforced(state) || isSingleDatasourceWithEncyptedExtract(targetItems);
}

function isClickableForExtractButton(targetItems: IDataSourceDetailInfo[], state: AppState) {
 return !hasFileBasedDatasource(targetItems) && !isAnyPendingExtractStatus(targetItems) && !isAnyVirtualConnectionDatasource(targetItems) && (isSingleLiveDatasource(targetItems) || isEncryptionEnabled(state));
}
